
import { useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";
import * as XLSX from 'xlsx';
import GreenButton from '../../../../ui/GreenButton.js';

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Input = styled.input`
  width: 400px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 7px;
  height: 37px;
  margin-left: 100px;
  
`;

const Button = styled.button`
  padding: 0px 20px ;
  cursor: pointer;
  border-radius: 2px;
  border: none;
  background-color:  #fff;
  height: 42px;
  font-size: 16px;
  font-weight: bold;
  margin: 5px;
  color: #575757;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.1);

  }
`;

const TableWrapper = styled.div`

  overflow: auto;
  border-radius: 7px;
  background: #fff;
  

  max-width: 98%;   /* limite de largura */
  margin: auto;   /* centraliza */
  padding: 12px;/* leve respiro interno */
`;


export const Table = styled.table`
 
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  /* (opcionais do seu layout externo) */
  box-shadow: 0 0 2px #ccc;
  border-radius: 7px;
  margin-bottom: 10px;

  /* células padrão */
  th, td {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
  }

  /* cabeçalho fixo */
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  /* listras + hover */
  tbody tr { transition: background 0.15s ease; }
  tbody tr:nth-child(even) { background: #fcfcfc; }
  tbody tr:hover { background: #E5F7EE; }

  /* divisórias e alinhamento */
  tbody td {
    border-bottom: 1px solid #f0f0f0;

  }
  tbody tr:last-child td { border-bottom: 0; }

  /* cantos arredondados */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  /* descrição com quebra — sem mudar seu JSX (4ª coluna) */
  tbody td:nth-child(4) {
    max-width: 520px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  @media (max-width: 780px) {
    min-width: 600px; /* força scroll horizontal no mobile */
    th, td { padding: 10px 12px; font-size: 13px; }
  }
`;


const ActionButton = styled.button`
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: transform .12s ease;
  &:hover { transform: scale(1.03); }
`;


export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

export const Tr = styled.tr`
  text-align: center;
  
  @media (max-width: 640px) {
    align-items: center; 
    text-align: center;
  }
  @media (max-width: 420px) {
    align-items: center; 
    text-align: center;
  }
`;

export const Th = styled.th`
  color: #555;
  text-align: left;
`;


export const Td = styled.td`
  word-break: break-word;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
`;



export const Td1 = styled.td`
  padding-top: 15px;
  text-align: center;

  
`;

export const Td2 = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
 
  
`;

export const Td3 = styled.div`

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  span{
    margin: 0px 5px;
  }

`;

const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Div2 = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;
const Div3 = styled.div`

  display: flex;
  align-items: center;
  justify-content:center;
  flex-direction: column;
  margin: auto;

`;

const LoadingMessage = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #555;
  text-align: center;
  margin: 30px;

  &::after {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 10px;
    border: 2px solid #ccc;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    vertical-align: middle;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
const Form = ({ listaChamadoTotal, modalVerChamadoFinalizado, setAtualizaFinalizados, atualizaFinalizados }) => {

  //-------------------------------------------------------------------------------------------------//
  const handleVerDados = () => {
    setAtualizaFinalizados(true);

  };

  const listaChamadosFiltrados = listaChamadoTotal;
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(listaChamadoTotal);



  //Input de pesquisa
  const handleSearch = async (term) => {
    try {
      const filtered = listaChamadosFiltrados.filter((user) => {
        const id = (user.ID_CHAMADO || '').toString().toLowerCase();
        const data = (user.DATA_FORMATADA3 || '').toString().toLowerCase();
        const desc = (user.DESC_PROBLEMA || '').toString().toLowerCase();
        const cod = (user.COD_FUNCIONARIO_SOLICITANTE || '').toString().toLowerCase();


        const passaFiltroPesquisa = desc.includes(term.toLowerCase()) ||
          id.includes(term.toLowerCase()) ||
          data.includes(term.toLowerCase()) ||
          cod.includes(term.toLowerCase());

        return passaFiltroPesquisa
      });

      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }

    setCurrentPage(1);
  };


  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, listaChamadoTotal]);

  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };





  const handleEdit = (item) => {
    modalVerChamadoFinalizado(item);

  };


  //---------------------------------------EXPORTAR EXCEL ---------------------------------------------------//


  const exportarParaExcel = (dados, nomeArquivo = 'chamados_total.xlsx') => {
    // Mapeia os dados para o Excel
    const dadosFormatados = dados.map(item => ({
      'Nº Chamado': item.ID_CHAMADO,
      'Data Criação': item.DATA_FORMATADA,
      'Data Capturado': item.DATA_FORMATADA2,
      'Data Finalizado': item.DATA_FORMATADA3,
      'Solicitante': item.Desc_Solicitante,
      'Tipo': item.Desc_TipoChamado,
      'SubTipo': item.Desc_SubTipoChamado,
      'ItemSubTipo': item.Desc_ItemSubTipoChamado,
      'Situação': item.DESC_SITUACAO,
      'Descrição': item.DESC_PROBLEMA,
      'Prioridade': item.DESC_PRIORIDADE,
      'Tipo Atendimento': item.DESC_TIPOATENDIMENTO,
      'Admin Atendeu': item.Desc_AdminAtendeu,
      'Admin Finalizou': item.Desc_AdminFinalizou,
      'Descrição Admin': item.DESC_ADMIN
    }));

    // Cria uma planilha
    const ws = XLSX.utils.json_to_sheet(dadosFormatados);

    // Cria um workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Chamados Total');

    // Exporta
    XLSX.writeFile(wb, nomeArquivo);
  };




  return (

    <>
      {atualizaFinalizados == null ? (
        <Tr>
          <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
            <GreenButton onClick={handleVerDados}>
              Ver todos os chamados...
            </GreenButton>
          </Td>
        </Tr>
      ) : (
        <Div>



          <Div3>
            <Td3 >

              <Input
                type="text"
                placeholder="Pesquisar..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Select value={itemsPerPage} onChange={(e) => {
                const value = e.target.value === "all" ? sortedData.length : parseInt(e.target.value);
                setItemsPerPage(value);
                setCurrentPage(1); // Resetar para a primeira página sempre que mudar
              }}>
                <option value={10}>10 por página</option>
                <option value={50}>50 por página</option>
                <option value={100}>100 por página</option>
                <option value="all">Todos</option>
              </Select>


              <Div2>
                <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                  <ImArrowLeft size={20} />
                </Button>
                <span><strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
                <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
                  <ImArrowRight size={20} />
                </Button>
              </Div2>

              <Div2>
                <GreenButton onClick={() => exportarParaExcel(listaChamadosFiltrados)}>
                  Exportar Excel
                </GreenButton>
              </Div2>

            </Td3>
            {atualizaFinalizados === true ? (
              <Tr>
                <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
                  <LoadingMessage>Carregando dados, por favor aguarde...</LoadingMessage>
                </Td>
              </Tr>
            ) : (
              <>
                {listaChamadoTotal.length === 0 ? (
                  <Tr>
                    <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
                      Nenhum chamado encontrado.
                    </Td>
                  </Tr>
                ) : (
                  <TableWrapper>
                    <Table>
                      <thead>
                        <tr>
                          <th onClick={() => onColumnClick("COD_FUNCIONARIO_SOLICITANTE")} className={getSortClass("COD_FUNCIONARIO_SOLICITANTE")}>
                            Solicitante: {getSortIcon("COD_FUNCIONARIO_SOLICITANTE")}
                          </th>

                          <th onClick={() => onColumnClick("DATA_FORMATADA3")} className={getSortClass("DATA_FORMATADA3")}>
                            Data Finalizado: {getSortIcon("DATA_FORMATADA3")}
                          </th>

                          <th onClick={() => onColumnClick("DESC_SITUACAO")} className={getSortClass("DESC_SITUACAO")}>
                            Situação: {getSortIcon("DESC_SITUACAO")}
                          </th>



                          <th onClick={() => onColumnClick("DESC_PROBLEMA")} className={getSortClass("DESC_PROBLEMA")}>
                            Descrição: {getSortIcon("DESC_PROBLEMA")}
                          </th>


                          <th></th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems.map((item, i) => (
                          <tr key={i}>
                            <td>{item.COD_FUNCIONARIO_SOLICITANTE} - {item.Primeiro_Nome_Solicitante}</td>
                            <td>{item.DATA_FORMATADA3}</td>
                            <td>{item.DESC_SITUACAO}</td>


                            {/* aplique a classe "desc" para aproveitar o wrap controlado */}
                            <td className="desc">
                              {item.DESC_PROBLEMA.length > 50
                                ? item.DESC_PROBLEMA.slice(0, 50) + '...'
                                : item.DESC_PROBLEMA}
                            </td>



                            <td>
                              <ActionButton onClick={() => handleEdit(item)}>
                                Ver informações
                              </ActionButton>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </TableWrapper>
                )}
              </>
            )}





          </Div3>
          <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
        </Div>
      )}
    </>
  );
};

export default Form;


